<div class="informational-message-container" [ngClass]="[type, size]" [@fadeIn]>
  <i class="fa fa-{{faIcon}}" *ngIf="faIcon" aria-hidden="true"></i>
  <span [innerHTML]="text | safeHTML">
  </span>
</div>